import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

export default function Landing() {
    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <header style={{
                background: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                padding: '20px 40px'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1 style={{ color: '#007bff', fontSize: '24px' }}>
                        {process.env.REACT_APP_PORTAL_NAME || 'Client Portal'}
                    </h1>
                    <Link to="/login">
                        <button className="btn btn-primary">Customer Login</button>
                    </Link>
                </div>
            </header>

            {/* Hero Section */}
            <main style={{ flex: 1, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '80px 40px',
                    color: 'white',
                    textAlign: 'center'
                }}>
                    <h2 style={{ fontSize: '48px', marginBottom: '20px', fontWeight: 'bold' }}>
                        Welcome to Your Client Portal
                    </h2>
                    <p style={{ fontSize: '20px', marginBottom: '40px', opacity: 0.9 }}>
                        Manage your services, view invoices, and get support - all in one place
                    </p>
                    <Link to="/login">
                        <button className="btn" style={{
                            padding: '15px 40px',
                            fontSize: '18px',
                            background: 'white',
                            color: '#667eea',
                            fontWeight: 'bold'
                        }}>
                            Access Your Account
                        </button>
                    </Link>
                </div>

                {/* Features */}
                <div style={{
                    maxWidth: '1200px',
                    margin: '60px auto 0',
                    padding: '0 40px'
                }}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '30px'
                    }}>
                        {[
                            { title: 'View Invoices', description: 'Access and download all your invoices' },
                            { title: 'Manage Tickets', description: 'Submit and track support requests' },
                            { title: 'Track Services', description: 'Monitor your active contracts and services' },
                            { title: 'Asset Management', description: 'View your equipment and licenses' }
                        ].map((feature, index) => (
                            <div key={index} style={{
                                background: 'rgba(255,255,255,0.1)',
                                backdropFilter: 'blur(10px)',
                                padding: '30px',
                                borderRadius: '12px',
                                border: '1px solid rgba(255,255,255,0.2)'
                            }}>
                                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>{feature.title}</h3>
                                <p style={{ opacity: 0.8 }}>{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer style={{
                background: '#333',
                color: 'white',
                padding: '30px 40px',
                textAlign: 'center'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    <p>© 2026 {process.env.REACT_APP_PORTAL_NAME}. All rights reserved.</p>
                    <p style={{ marginTop: '10px', opacity: 0.7 }}>
                        Need help? Contact us at <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`} style={{ color: '#667eea' }}>
                            {process.env.REACT_APP_SUPPORT_EMAIL}
                        </a>
                    </p>
                </div>
            </footer>
        </div>
    );
}
